import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./Pages/Home";
import StatusSaverPrivacyPolicy from "./Pages/StatusSaverPrivacyPolicy";
import SEO from "./Pages/SEO";
import MathFormulaPrivacyPolicy from "./Pages/MathFormulaPrivacyPolicy";
import GroceryTrackerPrivacyPolicy from "./Pages/GroceryTrackerPrivacyPolicy";
import StatusSaverDataDelete from "./Pages/StatusSaverDataDelete";
import "bootstrap/dist/css/bootstrap.min.css";
import JobDetails from "./JobFolder/JobDetails";
import AllApps from "./Pages/AllApps";
import Header from "./Header";
import AboutSection from "./Pages/AboutUs";
import ResumeBuilderPrivacyPolicy from "./Pages/ResumeBuilderPrivacyPolicy";

function App() {
  return (
    <HelmetProvider>
      <Header />
      <Router>
        <div>
          {/* Global SEO for the entire app */}
          <SEO />

          {/* Routes */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ourApps" element={<AllApps />} />
            <Route path="/job/:id" element={<JobDetails />} />
            <Route
              path="/StatusSaverPrivacyPolicy"
              element={<StatusSaverPrivacyPolicy />}
            />
            <Route
              path="/StatusSaverDataDelete"
              element={<StatusSaverDataDelete />}
            />
            <Route
              path="/MathFormulaPrivacyPolicy"
              element={<MathFormulaPrivacyPolicy />}
            />
            <Route
              path="/MathFormulaDataDelete"
              element={<StatusSaverDataDelete />}
            />
            <Route
              path="/GroceryTrackerPrivacyPolicy"
              element={<GroceryTrackerPrivacyPolicy />}
            />
            <Route
              path="/ResumeBuilderPrivacyPolicy"
              element={<ResumeBuilderPrivacyPolicy />}
            />
            <Route path="/aboutUs" element={<AboutSection />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
